/**
 * ConfirmDialog - Shared confirmation modal
 */

import React from 'react';
import { AlertTriangle, Info, XCircle } from 'lucide-react';

const VARIANT_CONFIG = {
  danger: { icon: XCircle, iconClass: 'text-red-600', btnClass: 'bg-red-600 hover:bg-red-700 text-white' },
  warning: { icon: AlertTriangle, iconClass: 'text-yellow-600', btnClass: 'bg-yellow-600 hover:bg-yellow-700 text-white' },
  info: { icon: Info, iconClass: 'text-primary-600', btnClass: 'bg-primary-600 hover:bg-primary-700 text-white' },
};

const ConfirmDialog = ({
  isOpen,
  onConfirm,
  onCancel,
  title = 'Confirm Action',
  message = 'Are you sure you want to proceed?',
  confirmLabel = 'Confirm',
  cancelLabel = 'Cancel',
  variant = 'danger',
  loading = false,
}) => {
  if (!isOpen) return null;

  const config = VARIANT_CONFIG[variant] || VARIANT_CONFIG.info;
  const IconComponent = config.icon;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      <div className="fixed inset-0 bg-black/50" onClick={onCancel} />
      <div className="relative bg-white rounded-lg shadow-xl max-w-md w-full mx-4 p-6">
        <div className="flex items-start space-x-3">
          <IconComponent size={24} className={config.iconClass} />
          <div>
            <h3 className="text-lg font-semibold text-gray-900">{title}</h3>
            <p className="text-sm text-gray-500 mt-1">{message}</p>
          </div>
        </div>
        <div className="flex justify-end space-x-3 mt-6">
          <button
            onClick={onCancel}
            disabled={loading}
            className="px-4 py-2 text-sm text-gray-700 border border-gray-300 rounded-lg hover:bg-gray-50 disabled:opacity-50"
          >
            {cancelLabel}
          </button>
          <button
            onClick={onConfirm}
            disabled={loading}
            className={`px-4 py-2 text-sm rounded-lg disabled:opacity-50 ${config.btnClass}`}
          >
            {loading ? 'Processing...' : confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
};

export default React.memo(ConfirmDialog);
